{
    "NavigationAll": "Tous",
    "NavigationReporting": "Rapportage",
    "NavigationAdministration": "Administration",
    "NavigationProvisioning": "Approvisionnement",
    "NavigationDevices": "Dispositifs",
    "NavigationEndpoints": "Points finaux",
    "NavigationTrunking": "Raccordements",
    "NavigationHospitality": "Hospitalité",
    "NavigationTrunkgateways": "Passerelles interurbaines",
    "NavigationVoicemailservices": "Services de messagerie vocale",
    "NavigationConferencedevices": "Dispositifs de conférence",
    "NavigationAgents": "Agents",
    "NavigationDirectory": "Annuaire",
    "NavigationCodes": "Codes",
    "NavigationPartitions": "Cloisons",
    "NavigationTelephonyservers": "Serveurs de téléphonie",
    "NavigationCmenvironments": "Environnements de gestion centrale",
    "NavigationApplicationusers": "Utilisateurs des applications",
    "NavigationOmnichannel": "Omnichannel",
    "NavigationRecording": "Enregistrement",
    "NavigationMessages": "Messages",
    "NavigationDatabase": "Base de données",
    "NavigationStatustools": "Statut et outils",
    "NavigationLicenses": "Licences",
    "NavigationLogging": "Enregistrement",
    "NavigationLogmanagement": "Gestion des journaux",
    "NavigationAudittrail": "Piste d'audit",
    "NavigationTelephonemodulestatus": "État du module téléphonique",
    "NavigationOmnichannelmodulestatus": "Statut omnicanal",
    "NavigationCallcontrol": "Contrôle des appels",
    "NavigationServerstatus": "Statut du serveur",
    "NavigationNewAnalytics": "Ajouter la société Insights",
    "NAME": "LanguageMainNavigation",
    "InsightsHub": "Perspectives",
    "Presence": "Présence",
    "NavigationUserManagement": "Gestion des utilisateurs",
    "NavigationManageUsersDevice": "Gérer les utilisateurs de l'entreprise",
    "NavigationEasyProvisioning": "Provisionnement facile",
    "NavigationManageQueues": "Gérer les files d'attente"
}